import { useTranslation } from 'next-i18next';
import { useDispatch } from 'react-redux';
import { useEventAccess } from '../../../../hooks/useEventAccess';
import { setPostRegistrationAction } from '../../../../reduxToolkit/slices/commonSlice';
import { useSelector } from '../../../../reduxToolkit/typedRedux';

export const StageSignupButton = () => {
  const event = useSelector((state) => state.common.event);
  const dispatch = useDispatch();
  const { loadUserData } = useEventAccess();
  const { t } = useTranslation();

  if (!event) return null;

  return (
    <div className={`w-full grid place-items-center `}>
      <button
        type="button"
        className={`text-base m-4 @md:text-2xl @md:m-0 mt-2 px-4 py-2 rounded border-none`}
        style={{
          backgroundColor: event?.template?.mainColor || 'var(--vystem-blue)',
          color: event?.template?.mainButtonTextColor ? event.template.mainButtonTextColor : 'white',
        }}
        onClick={() => {
          dispatch(
            setPostRegistrationAction(() => {
              loadUserData();
            })
          );
        }}>
        {t('event:register')}
      </button>
    </div>
  );
};

export default StageSignupButton;
